import React from 'react';
import { ShieldCheckIcon, BadgeCheckIcon, DownloadIcon, LockIcon, HeadphonesIcon } from 'lucide-react';
export function TrustBar() {
  const trustItems = [{
    icon: ShieldCheckIcon,
    text: 'Pago seguro'
  }, {
    icon: BadgeCheckIcon,
    text: 'Garantía'
  }, {
    icon: DownloadIcon,
    text: 'Descarga inmediata'
  }, {
    icon: LockIcon,
    text: 'Protección de datos'
  }, {
    icon: HeadphonesIcon,
    text: 'Soporte'
  }];
  return <div className="py-6 border-y border-[#E8D5C0] bg-[#FFF8F0]/80 backdrop-blur-sm" data-id="element-155">
      <div className="max-w-6xl mx-auto px-4" data-id="element-156">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-157">
          {trustItems.map((item, index) => <div key={index} className="flex items-center gap-2 text-[#92400E]" data-id="element-158">
              <item.icon className="w-5 h-5 text-[#C2410C]" data-id="element-159" />
              <span className="text-sm font-medium" data-id="element-160">{item.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}